export type ThemePreference = 'system' | 'light' | 'dark';

const STORAGE_KEY = 'pcp.theme';

export function readThemePreference(): ThemePreference {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
}

/** `system` remove o atributo e deixa valer `prefers-color-scheme`. */
export function applyTheme(pref: ThemePreference) {
  const root = document.documentElement;
  if (pref === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', pref);
}

export function saveThemePreference(pref: ThemePreference) {
  try {
    if (pref === 'system') window.localStorage.removeItem(STORAGE_KEY);
    else window.localStorage.setItem(STORAGE_KEY, pref);
  } catch {
    /* modo privado ou armazenamento bloqueado: o tema só não persiste */
  }
}

export const nextThemePreference = (pref: ThemePreference): ThemePreference =>
  pref === 'system' ? 'light' : pref === 'light' ? 'dark' : 'system';
